import React from 'react';

import { useReviewTemplate } from 'Shared/utils/hooks/use-review-template';
import ReviewForm from '../../../../../../ThreeSixtyReviewPartials/ReviewForm/ReviewForm';
import * as ReviewsUtils from 'Shared/utils/Reviews.utils';
import * as ReviewFormTemplatesHelpers from 'Shared/model_helpers/ReviewFormTemplates.helper';
import { Map, fromJS } from 'immutable';

type Props = {
  reviewTemplateSlug: string;
  answers: object;
  uuid: string;
};

function FeedbackFromReviewTemplateTemplateContext({ reviewTemplateSlug, answers, uuid }: Props) {
  const { reviewFormTemplates } = useReviewTemplate({ slug: reviewTemplateSlug, withFetch: false });

  if (!reviewFormTemplates || !reviewTemplateSlug) return null;

  const questions = ReviewFormTemplatesHelpers.getQuestions(Map(fromJS(reviewFormTemplates[0])));

  return (
    <ReviewForm
      formSlug={uuid}
      answers={ReviewsUtils.convertAnswersToSnakeCase(answers)}
      formData={{}}
      questions={questions}
    />
  );
}

export default FeedbackFromReviewTemplateTemplateContext;
